const PrimaryButton = ({
  children,
  onClick,
  className,
  type,
  mode = 'light',
  state = 'idle',
}: {
  children: string;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit';
  mode?: 'light' | 'dark';
  state?: 'loading' | 'idle';
}) => {
  return (
    <button
      type={type || 'button'}
      onClick={onClick}
      disabled={state === 'loading'}
      className={`bg-black hover:underline underline-offset-2 text-white w-72 min-w-full max-w-full px-2 py-3 flex items-center justify-center ${state === 'loading' ? 'opacity-80' : ''} ${className} ${
        mode === 'dark' ? 'border border-white' : ''
      }`}
    >
      {state === 'loading' ? (
        <div className="animate-spin rounded-full border-t-2 border-r-2 border-white h-5 w-5 mr-2"></div>
      ) : null}
      {children}
    </button>
  );
};

export default PrimaryButton;
